import * as Sentry from "@sentry/react";

export const initSentry = () => {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN_VE_AUCTION_FE || "",
    environment: process.env.REACT_APP_ENV || "development",
    release: process.env.REACT_APP_VERSION || "1.0.0",
    enabled: process.env.REACT_APP_ENV === "production",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.03,
    tracePropagationTargets: [
      /^https:\/\/(app|velynk|crmintegration|crmstaging)\.vegrow\.in/,
    ],
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.5,
  });
};
